import { render } from "./LoadingString.vue?vue&type=template&id=b87af82a"
import script from "./LoadingString.vue?vue&type=script&lang=js"
export * from "./LoadingString.vue?vue&type=script&lang=js"

import exportComponent from "/builds/apps/elevate/shepherd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__